enum ExperienceViewItemType {
    Experience = "experience",
    Section = "section",
}

interface ExperienceItemDto {
    /** DatesTimes as strings in a list */
    activeDates: string[];
    id: number;
    name: { [lang: string]: string };
    description: { [lang: string]: string };
    imageReference16x9?: string;
    imageReference1x1?: string;
    sortOrder: number;
    sectionIds: number[];
    bookingRequestEnabled?: boolean;
    bookingRequestOnly?: boolean;
    informationOnly?: boolean;
}

interface SectionItemDto {
    id: number;
    sortOrder: number;
    name: string;
    description: string;
    image: string;
}

interface ExperienceViewResponseDto {
    experiences: ExperienceItemDto[];
    sections: SectionItemDto[];
}

interface ExperienceViewExperienceItem {
    type: ExperienceViewItemType.Experience;
    id: number;
    sectionIds: number[];
    activeDates: string[];
    name: { [lang: string]: string };
    description: { [lang: string]: string };
    imageReference1x1?: string;
    imageReference16x9?: string;
    bookingRequestEnabled: boolean;
    /** Requests are the only way to book this experience, so its calendar has no bookable times to offer. */
    bookingRequestOnly: boolean;
    /** Shown without bookable times, so there is nothing to book whatever guests and date are chosen. */
    informationOnly: boolean;
}

interface ExperienceViewSectionItem {
    type: ExperienceViewItemType.Section;
    id: number;
    sectionIds: number[];
    activeDates: string[];
    name: string;
    description: string;
    imageReference1x1?: string;
    imageReference16x9?: string;
}

type ExperienceViewItem = ExperienceViewExperienceItem | ExperienceViewSectionItem;

function isExperienceItem(item: ExperienceViewItem): item is ExperienceViewExperienceItem {
    return item.type === ExperienceViewItemType.Experience;
}

function isSectionItem(item: ExperienceViewItem): item is ExperienceViewSectionItem {
    return item.type === ExperienceViewItemType.Section;
}

export { ExperienceViewItemType, isExperienceItem, isSectionItem };
export type {
    ExperienceViewItem,
    ExperienceViewExperienceItem,
    ExperienceViewSectionItem,
    ExperienceViewResponseDto,
};
